module.exports = __webpack_public_path__ + "img/1526723161.19c8049b.jpg";